import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Privacy from "@/pages/Privacy";

export const Route = createFileRoute("/_public/privacy")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Privacy Policy \u2014 Modern Fence Install", "How Modern Fence Install LLC collects, uses, shares, and protects information from visitors and customers of modernfenceinstall.com.", "/privacy", false),
  component: Privacy,
});
